module Meevo.Plugins.MerchantAccounts {
    "use strict";

    export class AdminSettingsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<any> {
        public useOnlyNumericCharacters = /^[0-9]{4,}$/;
        public useLettersNumbersSpecial = /^([A-Za-z0-9 -]*)$/;

        public isCustomizePayoutDescriptor: boolean;

        customAuditCriteria = {
            nounId: Model.NounEnum.MerchantAccountAdminSettings,
        };

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            protected modalService: Components.Modal.IModalService,
            sectionSecurityKey?: string,
            protected translateService?: angular.translate.ITranslateService
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);
            this.modalService = modalService;
        }

        public isSweepOverrideEnabled(): boolean {
            return this.model.customPayoutDescriptor !== null && this.model.customPayoutDescriptor !== undefined;
        }

        //handles subsequent partial/full updates. [partialSavedData] only contains properties that were sucessfully updated.
        public applyPartialSave(partialSavedData, hasErrors) {
            this.model = { ...this.model, ...partialSavedData };
            this.backup = { ...this.backup, ...partialSavedData };

            if (hasErrors) {
                this.handleErrorsAlert(this.model.errors);
            }

            this.isCustomizePayoutDescriptor = this.isSweepOverrideEnabled();
        }

        //handles only the initial call for this section
        sectionModelRetrieved() {
            this.isCustomizePayoutDescriptor = this.isSweepOverrideEnabled();
        }

        preSave() {
            if (this.isCustomizePayoutDescriptor !== true)
                this.model.customPayoutDescriptor = null;
        }

        handleErrorsAlert(warnings: any[]): ng.IPromise<boolean> {
            let message: string = "";
            for (let warning of warnings) {
                message += this.translateService.instant(warning.message) + "<br/>";
            }

            return this.modalService.alert(message, Components.Modal.ModalTranslationModes.DoNotTranslate);
        }
    }
}